export class IncorrectCredentialsError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class TooManyAttemptsError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class NewPasswordNeededError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class UserNotConfirmedError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class ResetPasswordCodeError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}
export class ExpiredCodeError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class UserNotDefinedError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}
export class UserNotFoundError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class LimitExceededCodeError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class TemporaryPasswordError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class SendLimitExceededError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class UsernameExistsCodeError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class NotAuthorizedCodeError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class CodeMismatchError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class UserInMultipleInfractureError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}
